<template>
  <div
    class="VisionProgressBar"
    :class="[
      'VisionProgressBar--height-' + height,
      { 'VisionProgressBar--rounded': rounded },
    ]"
  >
    <div
      class="VisionProgressBar__inner"
      :style="{ '--tw-scale-x': `${progress}%` }"
    />
  </div>
</template>

<script>
export default {
  name: 'VisionProgressBar',

  props: {
    progress: { type: Number, default: 0 },
    height: {
      type: String,
      default: 'thin',
      validator(value) {
        return ['thin', 'regular'].includes(value)
      },
    },
    rounded: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="postcss">
.VisionProgressBar {
  @apply bg-grey-400
        overflow-hidden
        h-1;
}

.VisionProgressBar--rounded,
.VisionProgressBar--rounded .VisionProgressBar__inner {
  @apply rounded-full;
}

.VisionProgressBar--height-regular {
  @apply h-2;

  .VisionProgressBar__inner {
    @apply h-2;
  }
}

.VisionProgressBar__inner {
  background: var(--gradient);

  @apply transition-transform
    duration-500
    transform origin-left
    h-1;
}
</style>
